import { useState, useEffect, useRef } from "react";
import { Form } from "antd";
import dayjs from "dayjs";
import Button from "@/common/elements/Button";
import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import {
  StyledFlex,
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
  StyledSubTableContainer,
} from "@/common/styles";
import CustomModal from "@/components/CustomModal";
import { TableHeader } from "@/components/InmateDetails/styles";
import {
  getDayjsObject,
  getOptionsFromRefList,
  getRefListNameByID,
  isNonEmptyVariable,
} from "@/util/common_function";
import DataTable from "@/common/elements/DataTable";
import { useDispatch, useSelector } from "react-redux";
import Popconfirm from "@/common/elements/Popconfirm";
import { setBookings, setDeleteAPis } from "@/slices/bookingsSlice";
import _ from "lodash";
import { v4 as uuidV4 } from "uuid";
import API_ENDPOINTS from "@/util/api";
import api from "@/services/axios_custom";
import { MODULES_LIST } from "@/util/common_variable";
import Administrator from "@/components/JailIncidents/Administrator";
import Supervisor from "@/components/JailIncidents/Supervisor";
import { setJailIncidentStore } from "@/slices/jailIncidents";

const SupplementalDetails = ({
  report = {},
  showAgencyInfo = false,
  supplementalListHeading = "List of supplementals to this officer report",
  from = MODULES_LIST.BOOKINGS,
  onSave = null,
  oldSupplimentals = [],
}) => {
  const dispatch = useDispatch();
  const { bookings, bookingsFieldsEnabled } = useSelector((s) => s?.bookings);
  const { jailIncident } = useSelector((s) => s?.jailIncident);
  const [supplementsList, setSupplementsList] = useState([]);
  const [showSupplementModal, setShowSupplementModal] = useState(false);
  const [selectedSupplement, setSelectedSupplement] = useState(null);
  const [supplementsListRows, setSupplementsListRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [oldSupplimentalsData, setOldSupplimentalsData] = useState([]);
  const [tableData, setTableData] = useState({
    headers: [
      { key: "id", text: "#" },
      { key: "filingDate", text: "Filing Date" },
      { key: "filingOfficerStaff", text: "Filing Officer" },
      { key: "fBadge", text: "Badge" },
      { key: "enteredByStaff", text: "Entered By" },
      { key: "eBadge", text: "Badge" },
    ],
    rows: [],
  });
  const datatableRef = useRef();
  const [form] = Form.useForm();
  let isDisabled =
    from == MODULES_LIST.BOOKINGS || from == MODULES_LIST.JAIL_INCIDENTS
      ? !bookingsFieldsEnabled
      : false;
  const [isModify, setisModify] = useState(isDisabled);

  useEffect(() => {
    if (isNonEmptyVariable(report)) {
      const supplementalsGroups = report?.officerReportsSupplementals || [];

      const supplementalDetails = supplementalsGroups
        ?.map((group, index) => {
          if (group?.supplementals?.length > 0) {
            const sup = group?.supplementals?.[0];
            const filingOfficerOptions =
              getOptionsFromRefList("Filing_Officer", true, true, true) || [];
            const filingOfficerOption = filingOfficerOptions.find(
              (opt) => opt.value === sup.filingOfficerStaffId,
            );

            const filingOfficerName = filingOfficerOption
              ? filingOfficerOption.label
              : sup.filingOfficerStaffId;
            const enteredByOption = filingOfficerOptions.find(
              (opt) => opt.value === sup.enteredByStaffId,
            );
            const enteredByName = enteredByOption
              ? enteredByOption.label
              : sup.enteredByStaffId;
            return {
              id: index + 1,
              filingDate: sup.filingDate || "",
              filingOfficerStaffId: filingOfficerName,
              enteredByStaffId: enteredByName,
              supplementalText: sup.supplemental || "",
              fullData: sup,
            };
          }
          return null;
        })
        .filter((item) => item !== null);

      if (supplementalDetails?.length) {
        setTableData((prev) => ({
          ...prev,
          rows: supplementalDetails,
        }));
      }
    }
  }, [report]);

  useEffect(() => {
    const loginUser = JSON.parse(localStorage.getItem("userDetails"));
    let setObj = {
      supplementals: [
        {
          filingOfficerStaffId: 1,
        },
      ],
    };
    if (isNonEmptyVariable(loginUser?.staffId)) {
      ["supplementals", 0, "filingOfficerStaffId"];
      setObj = {
        supplementals: [
          {
            filingOfficerStaffId: loginUser?.staffId,
          },
        ],
      };
    }
    form.setFieldsValue(setObj);

    if (from == MODULES_LIST.FACILITY_LOG) {
      setTableData({
        headers: [
          { key: "id", text: "#" },
          { key: "filingDate", text: "Filing Date" },
          { key: "filingOfficerStaff", text: "Filing Officer" },
          { key: "enteredByStaff", text: "Entered By" },
          { key: "supplemental", text: "supplemental" },
        ],
        rows: [],
      });
    } else if (from == MODULES_LIST.JAIL_INCIDENTS) {
      setTableData({
        headers: [
          { key: "jailIncidentsSupplementalId", text: "#" },
          { key: "filingDate", text: "Filing Date" },
          { key: "filingOfficerStaff", text: "Filing Officer" },
          { key: "enteredByStaff", text: "Entered By" },
          { key: "supplemental", text: "supplemental" },
        ],
        rows: [],
      });
    }
  }, []);

  useEffect(() => {
    const processSupplementals = async () => {
      if (from === MODULES_LIST.BOOKINGS && isNonEmptyVariable(bookings)) {
        setLoading(true);
        const sp = await Promise.all(
          bookings?.staffSupplementals?.map(async (s, index) => {
            const sp2 = await Promise.all(
              s?.supplementals?.map(async (e, i) => {
                const fBadge = await getBatchOfUser(e?.filingOfficerStaffId);
                const eBadge = await getBatchOfUser(e?.enteredByStaffId);

                return {
                  ...e,
                  id: index + 1,
                  uuid: uuidV4(),
                  filingOfficerStaff: isNonEmptyVariable(
                    e?.filingOfficerStaffId,
                  )
                    ? getRefListNameByID("", e?.filingOfficerStaffId, true)
                    : "",
                  fBadge: fBadge || "",
                  enteredByStaff: isNonEmptyVariable(e?.enteredByStaffId)
                    ? getRefListNameByID("", e?.enteredByStaffId, true)
                    : "",
                  eBadge: eBadge || "",
                };
              }),
            );

            return {
              staffSupplementalId: s?.staffSupplementalId,
              supplementals: sp2,
            };
          }),
        );

        setSupplementsList(() => sp);
      } else if (
        from === MODULES_LIST.JAIL_INCIDENTS &&
        isNonEmptyVariable(jailIncident)
      ) {
        setLoading(true);

        const sp = await Promise.all(
          jailIncident?.jailIncidentsSupplementals?.map(async (s, index) => {
            const sp2 = await Promise.all(
              s?.supplementals?.map(async (e, i) => {
                const fBadge = await getBatchOfUser(e?.filingOfficerStaffId);
                const eBadge = await getBatchOfUser(e?.enteredByStaffId);

                return {
                  ...e,
                  id: index + 1,
                  uuid: uuidV4(),
                  filingOfficerStaff: isNonEmptyVariable(
                    e?.filingOfficerStaffId,
                  )
                    ? getRefListNameByID(
                        "",
                        e?.filingOfficerStaffId,
                        true,
                        true,
                      )
                    : "",
                  fBadge: fBadge || "",
                  enteredByStaff: isNonEmptyVariable(e?.enteredByStaffId)
                    ? getRefListNameByID("", e?.enteredByStaffId, true, true)
                    : "",
                  eBadge: eBadge || "",
                  administratorDateTime: getDayjsObject(
                    e?.administratorDate,
                    e?.administratorTime,
                  ),
                  supervisorDateTime: getDayjsObject(
                    e?.supervisorDate,
                    e?.supervisorTime,
                  ),
                };
              }),
            );

            return {
              jailIncidentsSupplementalId: s?.jailIncidentsSupplementalId,
              supplementals: sp2,
            };
          }),
        );

        setSupplementsList(() => sp);
      } else {
        setSupplementsList([]);
      }
      setLoading(false);
    };

    processSupplementals();
  }, [bookings, jailIncident]);

  useEffect(() => {
    if (oldSupplimentals?.length) {
      setOldSupplimentalsData([...oldSupplimentals]);
    }
  }, [oldSupplimentals]);

  useEffect(() => {
    if (oldSupplimentalsData?.length) {
      let sp2 = oldSupplimentalsData?.map((e, i) => {
        return {
          ...e,
          id: i + 1,
          uuid: uuidV4(),
          filingOfficerStaff: isNonEmptyVariable(e?.filingOfficerStaffId)
            ? getRefListNameByID("", e?.filingOfficerStaffId, true)
            : "",
          enteredByStaff: isNonEmptyVariable(e?.enteredByStaffId)
            ? getRefListNameByID("", e?.enteredByStaffId, true)
            : "",
        };
      });
      setSupplementsListRows(sp2);
    }
  }, [oldSupplimentalsData]);

  async function getBatchOfUser(staffId) {
    if (isNonEmptyVariable(staffId)) {
      const url = API_ENDPOINTS.staff.staffByID;
      let resp = await api.get(url + staffId);
      let data = resp?.data;
      if (isNonEmptyVariable(data?.badge)) {
        return data?.badge;
      }
    } else {
      return "";
    }
  }

  useEffect(() => {
    if (from == MODULES_LIST.BOOKINGS) {
      let rowData = supplementsList?.map((e, i) => {
        let e1 = _.cloneDeep(e);
        if (e?.supplementals?.length) {
          e1.supplementals[0] = {
            ...e1.supplementals[0],
            staffSupplementalId: e1?.staffSupplementalId,
          };
        }
        return e1?.supplementals[0];
      });
      setSupplementsListRows(rowData);
    } else if (from == MODULES_LIST.JAIL_INCIDENTS) {
      let rowData = supplementsList?.map((e, i) => {
        let e1 = _.cloneDeep(e);
        if (e?.supplementals?.length) {
          e1.supplementals[0] = {
            ...e1.supplementals?.[0],
            jailIncidentsSupplementalId: e1?.jailIncidentsSupplementalId,
          };
        }
        return e1?.supplementals[0];
      });
      setSupplementsListRows(rowData);
    }
  }, [supplementsList]);

  const onRowClick = (value, index) => {
    if (isNonEmptyVariable(value)) {
      const data = {
        ...value,
        filingDate: isNonEmptyVariable(value?.filingDate)
          ? dayjs(value?.filingDate)
          : null,
      };
      setSelectedSupplement(() => {
        return { supplementals: [{ ...data }] };
      });
    }
    if(index !== undefined && index !== null) {
      onEditClick("view")
    }
  };

  const onAddClick = () => {
    setisModify(true);
    setSelectedSupplement(() => null);
    setShowSupplementModal(true);
  };

  const onEditClick = (action) => {
    if (action === "view") {
      setisModify(false);
    } else {
      setisModify(true);
    }
    setShowSupplementModal(true);
    form.setFieldsValue(selectedSupplement);
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then(async (data) => {
        let data2 = data?.supplementals[0];
        if (data2?.filingDate)
          data2.filingDate = dayjs(data2.filingDate).format("MM/DD/YYYY");
        if (from == MODULES_LIST.BOOKINGS) {
          let supplementsListData = _.cloneDeep(supplementsList);
          if (isNonEmptyVariable(selectedSupplement)) {
            supplementsListData = supplementsListData?.map((m) => {
              if (
                m?.supplementals[0]?.uuid ===
                selectedSupplement?.supplementals[0]?.uuid
              ) {
                m.supplementals[0] = {
                  ...m?.supplementals[0],
                  ...data?.supplementals[0],
                };
                return {
                  ...m,
                };
              }
              return m;
            });
          } else {
            supplementsListData?.push(data);
          }
          setSupplementsList(() => supplementsListData);

          dispatch(
            setBookings({
              staffSupplementals: supplementsListData,
            }),
          );
        } else if (from == MODULES_LIST.FACILITY_LOG) {
          let supplementsListData = _.cloneDeep(supplementsListRows);
          let newData = data?.supplementals[0];
          if (isNonEmptyVariable(selectedSupplement)) {
            let newSupplimental = selectedSupplement?.supplementals[0];
            if (isNonEmptyVariable(newSupplimental)) {
              let newSupplimentalList = supplementsListData?.map((e, i) => {
                if (e?.uuid == newSupplimental?.uuid) {
                  let newObj = {
                    ...e,
                    ...newData,
                    filingOfficerStaff: isNonEmptyVariable(
                      newData?.filingOfficerStaffId,
                    )
                      ? getRefListNameByID(
                          "",
                          newData?.filingOfficerStaffId,
                          true,
                        )
                      : "",
                    enteredByStaff: isNonEmptyVariable(
                      newData?.enteredByStaffId,
                    )
                      ? getRefListNameByID("", newData?.enteredByStaffId, true)
                      : "",
                  };
                  return { ...newObj };
                } else {
                  return {
                    ...e,
                  };
                }
              });
              setOldSupplimentalsData([...newSupplimentalList]);
              setSelectedSupplement(null);
              onSave(newSupplimentalList);
            }
          } else {
            if (isNonEmptyVariable(newData)) {
              oldSupplimentals.push(newData);
              setOldSupplimentalsData([...oldSupplimentalsData, newData]);
              onSave(oldSupplimentals);
            }
          }
        } else if (from == MODULES_LIST.JAIL_INCIDENTS) {
          let supplementsListData = _.cloneDeep(supplementsList);
          const supervisorAdmin = {
            supervisorDate:
              selectedSupplement?.supplementals?.[0]?.supervisorDate || null,
            supervisorTime:
              selectedSupplement?.supplementals?.[0]?.supervisorTime || null,
            supervisorReject:
              selectedSupplement?.supplementals?.[0]?.supervisorReject || null,
            supervisorRejectReason:
              selectedSupplement?.supplementals?.[0]?.supervisorRejectReason ||
              null,
            supervisorStaffId:
              selectedSupplement?.supplementals?.[0]?.supervisorStaffId || null,
            supervisorStatus:
              selectedSupplement?.supplementals?.[0]?.supervisorStatus || null,
            administratorDate:
              selectedSupplement?.supplementals?.[0]?.administratorDate || null,
            administratorReject:
              selectedSupplement?.supplementals?.[0]?.administratorReject ||
              null,
            administratorRejectReason:
              selectedSupplement?.supplementals?.[0]
                ?.administratorRejectReason || null,
            administratorStaffId:
              selectedSupplement?.supplementals?.[0]?.administratorStaffId ||
              null,
            administratorStatus:
              selectedSupplement?.supplementals?.[0]?.administratorStatus ||
              null,
            administratorTime:
              selectedSupplement?.supplementals?.[0]?.administratorTime || null,
          };
          if (isNonEmptyVariable(selectedSupplement?.supplementals[0]?.uuid)) {
            supplementsListData = supplementsListData?.map((m) => {
              if (
                m?.supplementals[0]?.uuid ===
                selectedSupplement?.supplementals[0]?.uuid
              ) {
                m.supplementals[0] = {
                  ...m?.supplementals?.[0],
                  ...data?.supplementals?.[0],
                  ...supervisorAdmin,
                };
                return {
                  ...m,
                };
              }
              return m;
            });
          } else {
            supplementsListData?.push({
              ...data,
              supplementals: [
                {
                  ...data?.supplementals?.[0],
                  ...supervisorAdmin,
                },
              ],
            });
          }

          setSupplementsList(() => supplementsListData);

          dispatch(
            setJailIncidentStore({
              jailIncidentsSupplementals: supplementsListData,
            }),
          );
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        handleCancel();
      });
  };

  const handleCancel = () => {
    setSelectedSupplement(() => null);
    setShowSupplementModal(false);
    datatableRef?.current?.resetAll();
    form.resetFields();
  };

  const handleDelete = () => {
    try {
      if (from == MODULES_LIST.BOOKINGS) {
        let supplementsListData = _.cloneDeep(supplementsList);
        if (isNonEmptyVariable(selectedSupplement)) {
          supplementsListData = supplementsListData?.filter((m) => {
            if (
              m?.supplementals[0]?.uuid !==
              selectedSupplement?.supplementals[0]?.uuid
            ) {
              return true;
            }
          });
          if (
            isNonEmptyVariable(
              selectedSupplement?.supplementals[0]?.staffSupplementalId,
            )
          ) {
            const url =
              API_ENDPOINTS.staff.supplementsList.delete +
              selectedSupplement?.supplementals[0]?.staffSupplementalId;
            dispatch(setDeleteAPis(url));
          }
        }
        setSupplementsList(() => supplementsListData);
        dispatch(
          setBookings({
            staffSupplementals: [...supplementsListData],
          }),
        );
      } else if (from == MODULES_LIST.JAIL_INCIDENTS) {
        let supplementsListData = _.cloneDeep(supplementsList);
        if (isNonEmptyVariable(selectedSupplement)) {
          supplementsListData = supplementsListData?.filter((m) => {
            if (
              m?.supplementals[0]?.uuid !==
              selectedSupplement?.supplementals[0]?.uuid
            ) {
              return true;
            }
          });

          if (
            isNonEmptyVariable(
              selectedSupplement?.supplementals?.[0]
                ?.jailIncidentsSupplementalId,
            )
          ) {
            const url =
              API_ENDPOINTS.jailIncidents.deleteSupplements +
              selectedSupplement?.supplementals?.[0]
                ?.jailIncidentsSupplementalId;
            dispatch(setDeleteAPis(url));
          }
        }
        setSupplementsList(() => supplementsListData);
        dispatch(
          setJailIncidentStore({
            jailIncidentsSupplementals: [...supplementsListData],
          }),
        );
      }
    } catch (error) {
    } finally {
      handleCancel();
    }
  };

  const updateForm = (data) => {
    setSelectedSupplement((prev) => ({
      ...(prev || {}),
      supplementals: [
        {
          ...(prev?.supplementals?.[0] || {}),
          ...data,
        },
      ],
    }));
  };

  return (
    <>
      <StyledSubTableContainer>
        <TableHeader justify="space-between">
          <h2>{supplementalListHeading}</h2>
          <StyledFlex gap="10px">
            <Button
              color="primary"
              type="primary"
              className="add-btn"
              onClick={onAddClick}
              disabled={isDisabled}
            >
              Add
            </Button>
            <Button
              color="primary"
              type="primary"
              onClick={() => onEditClick("view")}
              disabled={selectedSupplement === null}
            >
              Details
            </Button>
            <Button
              color="primary"
              type="primary"
              onClick={() => onEditClick("edit")}
              disabled={selectedSupplement === null || isDisabled}
            >
              Modify
            </Button>
            <Popconfirm
              title="Delete the supplement"
              description="Are you sure to delete this supplement?"
              onConfirm={handleDelete}
              onCancel={() => {}}
              okText="Yes"
              cancelText="No"
            >
              {from != MODULES_LIST.FACILITY_LOG && (
                <Button
                  color="primary"
                  type="primary"
                  disabled={selectedSupplement === null || isDisabled}
                >
                  Delete
                </Button>
              )}
            </Popconfirm>
            <Button
              color="primary"
              type="primary"
              disabled={selectedSupplement === null || isDisabled}
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </StyledFlex>
        </TableHeader>
        <DataTable
          ref={datatableRef}
          rowUniqueId="uuid"
          headers={tableData.headers}
          data={supplementsListRows || []}
          onRowClick={onRowClick}
          selected={selectedSupplement === null}
          allowTableSorting={true}
          isAPiCallLoading={loading}
        />
      </StyledSubTableContainer>

      {showSupplementModal && (
        <CustomModal
          show={showSupplementModal}
          header="Supplemental Details"
          size="xl"
          onHide={() => {
            setShowSupplementModal(false);
            setSelectedSupplement(null);
            handleCancel();
          }}
          onSaveClick={handleSubmit}
          isDisabled={!isModify}
        >
          <Form form={form} layout="vertical" disabled={isDisabled}>
            <StyledSectionHeading>
              <span>Supplemental Information</span>
            </StyledSectionHeading>
            <StyledGridRow gutter={16} justify={"start"}>
              <StyledGridCol xs={6}>
                <FormItem
                  label="Filing Officer"
                  name={["supplementals", 0, "filingOfficerStaffId"]}
                >
                  <Select
                    options={getOptionsFromRefList(
                      "Filing_Officer",
                      true,
                      false,
                      true,
                    )}
                    placeholder="Select Filing Officer"
                    disabled={!isModify}
                  />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol xs={6}>
                <FormItem
                  label="Filing Date"
                  name={["supplementals", 0, "filingDate"]}
                >
                  <CommonDatePicker
                    format="MM/DD/YYYY"
                    showTime={false}
                    disabled={!isModify}
                  />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol xs={6}>
                <FormItem
                  label="Entered By"
                  name={["supplementals", 0, "enteredByStaffId"]}
                >
                  <Select
                    options={getOptionsFromRefList(
                      "Filing_Officer",
                      true,
                      false,
                      true,
                    )}
                    placeholder="Select Entered By"
                    disabled={!isModify}
                  />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
            <StyledGridRow gutter={16}>
              <StyledGridCol xs={24}>
                <FormItem
                  label="Supplemental"
                  name={["supplementals", 0, "supplemental"]}
                >
                  <TextField
                    inputType="textarea"
                    rows={5}
                    disabled={!isModify}
                  />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
            <Supervisor
              data={selectedSupplement?.supplementals?.[0]}
              parentFieldEnable={isModify}
              fromkey="supplementals"
              updateForm={updateForm}
            />

            <Administrator
              data={selectedSupplement?.supplementals?.[0]}
              parentFieldEnable={isModify}
              fromkey="supplementals"
              updateForm={updateForm}
            />

            {showAgencyInfo && (
              <>
                <StyledSectionHeading>
                  <span>Agency-Specific General Supplemental Information</span>
                </StyledSectionHeading>
                <StyledGridRow gutter={16}>
                  <StyledGridCol lg={12}>
                    <FormItem
                      label="Agency Supplemental Code"
                      name={["supplementals", 0, "agencySupplementalCodeU"]}
                    >
                      <TextField
                        id="agencySupplementalCode"
                        disabled={!isModify}
                      />
                    </FormItem>
                  </StyledGridCol>
                </StyledGridRow>
              </>
            )}
          </Form>
        </CustomModal>
      )}
    </>
  );
};

export default SupplementalDetails;
